import * as React from 'react';
import { IconColors } from './IconColors';
import { IconProps } from './IconProps';

// eslint-disable-next-line import/prefer-default-export
export const SVGWrapper: React.FC<IconProps> = ({
    aspect,
    children,
    color,
    fill = 'none',
    style = {},
    viewBox = '0 0 24 24',
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox={viewBox}
        fill={fill}
        stroke={color || IconColors.Action}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{
            color: color || IconColors.Action,
            height: aspect?.length ? aspect : '1.25rem',
            minWidth: '1rem',
            width: aspect?.length ? aspect : '1.25rem',
            ...style,
        }}
    >
        {children}
    </svg>
);
